import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons';
import { toSlug } from '@/helpers/common';
import { Modals } from '@/helpers/modals';
import { useNavigation } from '@/hooks/navigation';
import { ScheduleStatus } from '@/modules/common/helpers';
import { useModalsStore } from '@/store';

interface ITournamentActionButton {
  preview?: boolean;
  mode: ScheduleStatus;
  name: string;
  isAuthenticated: boolean;
}

export const TournamentActionButton: FC<ITournamentActionButton> = ({
  preview,
  mode,
  name,
  isAuthenticated,
}) => {
  const { t } = useTranslation('common');

  const open = useModalsStore.use.open();
  const { generateLink } = useNavigation();

  const isFinished = useMemo(() => mode === ScheduleStatus.FINISHED, [mode]);
  const isComingSoon = useMemo(
    () => mode === ScheduleStatus.COMING_SOON,
    [mode]
  );

  if (preview) {
    return (
      <Button
        large
        primary={!(isComingSoon || isFinished)}
        to={generateLink(`/tournaments/${toSlug(name)}`)}
        wide
      >
        {t('details')}
      </Button>
    );
  }

  if (isAuthenticated) {
    if (isFinished) return null;

    return (
      <Button large onClick={() => open(Modals.Deposit)} primary wide>
        {t('button.deposit')}
      </Button>
    );
  }

  return (
    <Button large onClick={() => open(Modals.Registration)} primary wide>
      {t('button.register')}
    </Button>
  );
};
